<bs-linear-module-container [expandable]="isModuleCollapsible" [trackingBetslipTypeContext]="betslipType">
    <ng-template [bsLinearModuleHeader]>
        @if (isModuleCollapsible || isEpcotEnabled) {
            <div class="combo-bet-linear__header">{{ comboHeaderTitle }}</div>
        }
    </ng-template>

    <ng-template [bsLinearModuleContent]>
        <div [ngClass]="{ 'combo-bet-linear--main': showMainComboContainer(), 'combo-bet-linear--bet-builder': showBetBuilderComboList }">
            @if (showMainComboContainer()) {
                <bs-linear-main-combo-container
                    [pickList]="pickList()"
                    [comboBetState]="comboBetState()"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [removeButtonPosition]="removeButtonPosition"
                    [removeButtonStyle]="removeButtonStyle"></bs-linear-main-combo-container>
            }

            @if (showBetBuilderComboList) {
                <bs-linear-bet-builder-combo-list
                    [removeButtonStyle]="removeButtonStyle"
                    [oddsDisplayFormat]="oddsDisplayFormat"></bs-linear-bet-builder-combo-list>
            }
        </div>
    </ng-template>
</bs-linear-module-container>
